@import 'styles/blaze/mixins';
@import 'styles/mixins';

.cardButton {
  cursor: pointer;
  display: flex;
  width: 100%;
  border-radius: 15px;
  background: var(--dark-4);
  position: relative;
  overflow: hidden;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--dark-8);
  }

  &:focus {
    outline: none;
  }

  &.selected {
    background-color: var(--selected-fill);
    color: var(--light-100);

    .label {
      color: var(--light-100);
    }

    .subLabel {
      color: var(--light-80);
    }
  }

  &.horizontal {
    flex-direction: row;
    aspect-ratio: 3 / 2;
    max-width: 360px;
  }

  &.vertical {
    flex-direction: column;
    aspect-ratio: 1 / 1.3;
    max-width: 180px;
  }

  &.square {
    flex-direction: row;
    aspect-ratio: 1;
    max-width: 360px;

    .label {
      font-size: 18px;
    }
  }

  &.list {
    flex-direction: column;
    aspect-ratio: 7 / 2;

    .content {
      height: 100%;
      justify-content: center;
      padding-left: 25px;
    }

    .label {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0.18px;
    }

    .subLabel {
      font-size: 16px;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: 0.32px;
    }
  }

  &.md {
    .label {
      font-size: 18px;
    }
  }
}

.icon {
  position: absolute;
  bottom: 14px;
  left: 14px;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 2;
  gap: 2px;
}

.label {
  color: var(--dark-80);
  font-family: Sohne;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.16px;
  text-align: start;
  transition: color 0.2s ease;
}

.subLabel {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  text-align: start;
  transition: color 0.2s ease;
}

.media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.pressed {
  background-color: rgba(0, 0, 0, 0.1);
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (min-width: $phoneMaxWidth) {
  .cardButton {
    &.md {
      .label {
        font-size: 24px;
      }
    }
  }
}
